<script lang="ts">
  // types
  import type { Readable } from 'svelte/store';
  import type { RaceInterface } from '../interfaces';
  import { intcomma } from 'journalize';
  import { formatPercent } from '../utils/format.js';

  /** @type {import('../types.d').ReadableRace} */
  export let race;


  // $: console.log($race);
  let alwaysShowCandidates = 4;
  let shouldSortCandidates = false;
  let voteLabel = 'total';
  let hidePrecincts = false;

  $: caption = $race.race_type === 'G' ? `` : $race.seat_name;
  const raceId = $race.id;
  const captionNote = $race.description;
  const candidates = $race.candidates;
  const totalVotes = $race.total_votes;
  const office = $race.office;
  const precinctsReportingPercent = $race.precincts_reporting_percent;
  const eevp = $race.eevp;
  const numOfwinners = $race.number_of_winners;
  const numberOfCandidates = candidates.length;
  $: tooFewToHide = numberOfCandidates <= alwaysShowCandidates + 1;

  let viewAllCandidates = false;

  const isBallotMeasure = office === 'I';

  $: preppedCandidates = shouldSortCandidates
    ? candidates.sort((a, b) => descending(a.votes, b.votes))
    : candidates;

  $: numDecimalsInPercent = raceId === 'GA-S12301-2020-11-03' ? 3 : undefined;
</script>

<div class="contest mt-0">
  <table class="contest__candidates">
    {#if caption}
      <caption class="contest__caption text-left">
        <p>
          {caption}
          {#if captionNote}
            <span class="text-xs text-regular color-grey">{captionNote}</span>
          {/if}
        </p>
      </caption>
    {/if}

    <!-- HEADER -->
    <thead>
      <tr>
        <th scope="col" colSpan={1} class="contest__candidate-header" />
        <th scope="col" colSpan="1" class="contest__candidate-header">
          <!-- {isBallotMeasure ? 'Support' : 'Candidate'} -->
        </th>
        <th scope="col" class="contest__candidate-header text-left">
          <span>% votes</span>
        </th>
        <th scope="col" class="contest__candidate-header text-left">
          {voteLabel}
        </th>
      </tr>
    </thead>

    <tbody>
      {#each preppedCandidates as candidate, idx (candidate.ap_id)}
        <tr
          class="candidate contest__candidate-row contest__candidate-row-{candidate.party}"
          hidden={!(
            viewAllCandidates ||
            tooFewToHide ||
            idx < alwaysShowCandidates
          )}
        >
          <th
            scope="row"
            class="candidate__cell candidate__cell-name"
            class:candidate__cell-name-winner={candidate.is_winner |
              candidate.is_runoff}
          >
            {#if candidate.is_winner}
              <span class="candidate__cell-winner candidate__{candidate.party}">
                ✓
              </span>
            {/if}
          </th>
          <th
            scope="row"
            class="candidate__cell candidate__cell-name"
            class:candidate__cell-name-winner={candidate.is_winner |
              candidate.is_runoff}
          >
            {#if candidate.given_name}{candidate.given_name}{/if}
            {candidate.family_name}
            {#if candidate.is_incumbent}
              <span
                class="candidate__cell-incumbent"
                title="Currently holds this office"
                role="img"
                aria-label="incumbent">*</span
              >
            {/if}
          </th>

          <td
            class="candidate__cell candidate__cell-pct candidate__cell-pct-{candidate.is_winner
              ? 'w'
              : 'l'} {candidate.isWinner ? 'text-medium' : ''} text-left"
            class:candidate__cell-ballot-measures={isBallotMeasure}
          >
            <div>
              <span
                class="candidate__pct-bar candidate__pct-bar-{candidate.family_name.toLowerCase()} "
                style="width: {formatPercent(
                  candidate.votes,
                  totalVotes,
                  numDecimalsInPercent
                )}%"
              />
              {formatPercent(candidate.votes, totalVotes, numDecimalsInPercent)}
              <span class="candidate__pct-symbol">%</span>
            </div>
          </td>

          <td
            class="candidate__cell candidate__cell-votes text-right"
            class:candidate__cell-ballot-measures={isBallotMeasure}
          >
            {intcomma(candidate.votes)}
          </td>
        </tr>
      {/each}
      {#if !tooFewToHide}
        <tr class="candidate contest__candidate-row">
          <th colspan="4" scope="row" class="candidate__cell p-0">
            <button on:click={() => (viewAllCandidates = !viewAllCandidates)}>
              View
              {viewAllCandidates ? 'fewer' : 'all'}
              candidates
              <svg
                class="icon"
                class:icon-angle-down={!viewAllCandidates}
                class:icon-angle-up={viewAllCandidates}
              >
                <use
                  xlink:href="#{viewAllCandidates
                    ? 'icon-angle-up'
                    : 'icon-angle-down'}"
                />
              </svg>
            </button>
          </th>
        </tr>
      {/if}
    </tbody>
    <tfoot>
      <tr>
        <!-- <td
          colspan={(hasParties| face)? 2:1}
          class="contest__precincts">
          {intcomma(totalVotes)}
          total vote{pluralize(totalVotes)}
        </td> -->
        <td colspan="3" class="contest__precincts text-left">
          {#if !hidePrecincts}
            {#if eevp}
              {eevp}% of expected vote in
            {:else}{precinctsReportingPercent}% precincts reporting{/if}
          {/if}
        </td>
      </tr>
    </tfoot>
  </table>
</div>
